export default __webpack_public_path__ + "static/media/social-club.6ec07d9f.jpg";